import type { QueryKey } from '@tanstack/react-query';

const queryKeys = {
  adSets: ['api', 'v1', 'facebook_manager', 'get_adsets'],
  domains: ['api', 'v1', 'facebook_manager', 'get_domains'],
  campaigns: ['api', 'v1', 'facebook_manager', 'get_campaigns'],
  callToActions: ['api', 'v1', 'facebook_manager', 'get_call_to_actions'],
  adTypes: ['api', 'v1', 'facebook_manager', 'get_ad_types'],
  adSettings: ['api', 'v1', 'facebook_manager', 'get_ad_settings'],
  adAccounts: ['api', 'v1', 'facebook_manager', 'get_ad_accounts'],
  allTestCreatives: ['api', 'v1', 'creative_manager', 'get_creatives_with_hypothesis'] as QueryKey,
  testCreatives: <TParams>(params?: TParams) =>
    ['api', 'v1', 'creative_manager', 'get_creatives_with_hypothesis', params] as QueryKey,
  hypothesisSection: ['api', 'v1', 'creative_manager', 'creative', 'update'] as QueryKey,
  filterOptions: <TParams>(params?: TParams) =>
    ['api', 'v1', 'creative_manager', 'filter_options', params] as QueryKey,
};
export default queryKeys;